import { parse, isPast } from 'date-fns';

import type translations from './.vocab/translations.json';

type TranslationKeys = keyof typeof translations;

export interface Invalid {
  valid: false;
  errorMessage: TranslationKeys;
}

export interface Valid {
  valid: true;
  expiredDate: Date;
}

export const validateExpiryDate = (
  expiryDateString: string,
): Valid | Invalid => {
  if (expiryDateString.trim().length === 0) {
    return {
      valid: false,
      errorMessage: 'Please add expiry date',
    };
  }

  // Ensures in DST job is expired just before midnight in Perth time
  // matching job posting expiry logic
  const expiredDate = parse(
    `${expiryDateString} +11 23:59:59`,
    'dd/MM/yyyy X kk:mm:ss',
    new Date(),
  );
  if (isNaN(expiredDate.getTime())) {
    return {
      valid: false,
      errorMessage: 'Expiry date is in invalid format...',
    };
  }

  if (isPast(expiredDate)) {
    return {
      valid: false,
      errorMessage: 'Expiry date cannot be in the past',
    };
  }

  return {
    expiredDate,
    valid: true,
  };
};
